// frontend/src/components/Admin/AssignUser.js
import React, { useState } from "react";
import axios from "axios";
import { Form, Button, Alert, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./AdminCSS/operations.css"; // Reuse existing styles

const API_URL = process.env.REACT_APP_API_URL;


const AssignUser = () => {
  const [email, setEmail] = useState("");
  const [patientId, setPatientId] = useState("");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // const handleAssign = async (e) => {
  //   e.preventDefault();
  //   setMessage(null);
  //   setError(null);
  //   setLoading(true);

  //   try {
  //     const res = await axios.post(`${API_URL}/assignments/assign-user`, {
  //       email,
  //       patient_id: Number(patientId),
  //     });

  //     setMessage(res.data.message);
  //     setEmail("");
  //     setPatientId("");
  //   } catch (err) {
  //     setError(
  //       err.response?.data?.detail ||
  //       err.response?.data ||
  //       "Unable to assign user. Check inputs."
  //     );
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleAssign = async (e) => {
  e.preventDefault();
  setMessage(null);
  setError(null);
  setLoading(true);

  try {
    // 🔹 Retrieve token from sessionStorage or localStorage
    const token =
      sessionStorage.getItem("access_token") ||
      localStorage.getItem("access_token");

    if (!token) {
      setError("Unauthorized: Missing access token. Please log in again.");
      navigate("/login");
      return;
    }

    // 🔹 Make authorized request
    const res = await axios.post(
      `${API_URL}/assignments/assign-user`,
      {
        email,
        patient_id: Number(patientId),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    setMessage(res.data.message);
    setEmail("");
    setPatientId("");
  } catch (err) {
    console.error("Error assigning user:", err);
    if (err.response && err.response.status === 401) {
      setError("Unauthorized: Please log in again.");
      navigate("/login");
    } else {
      setError(
        err.response?.data?.detail ||
          err.response?.data ||
          "Unable to assign user. Check inputs."
      );
    }
  } finally {
    setLoading(false);
  }
};

  const handleClose = () => {
    navigate("/admindashboard");
  };

  return (
    <div className="add-patient-wrapper">
      <div className="add-patient-container">
        <div className="header">
          <h3>Assign User to Patient</h3>
          <button className="close-button" onClick={handleClose}>&times;</button>
        </div>

        {message && <Alert variant="success">{message}</Alert>}
        {error && <Alert variant="danger">{typeof error === "object" ? JSON.stringify(error) : error}</Alert>}

        <Form onSubmit={handleAssign}>
          <Form.Group>
            <Form.Label>User Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="e.g. user@email.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Patient ID</Form.Label>
            <Form.Control
              type="number"
              placeholder="Enter Patient ID"
              value={patientId}
              onChange={e => setPatientId(e.target.value.replace(/\D/g, ""))}
              required
            />
          </Form.Group>

          <Button className="btn btn-primary mt-3" type="submit" disabled={loading}>
            {loading ? <><Spinner animation="border" size="sm" className="me-2" /> Assigning...</> : <>Assign User</>}
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default AssignUser;